module.exports = __webpack_public_path__ + "img/review-icon.cab5361c.png";